import { TextField as MuiTextField, styled } from "@mui/material";
import type { Components, Theme } from "@mui/material/styles";

export const TextField = styled(MuiTextField)`
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
`;

const InputStyles: Components<Omit<Theme, "components">> = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        ...(ownerState.multiline
          ? { alignItems: "flex-start", height: "auto", padding: 0 }
          : { height: 40 }),
        "& .MuiOutlinedInput-notchedOutline": {
          borderWidth: "1px",
          borderColor: theme.palette.strokeColor.primary,
        },
      }),
      input: ({ theme }) => ({
        "fontSize": "14px",
        "&::placeholder": {
          color: theme.palette.text.placeholder,
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "20px",
          opacity: 1,
        },
      }),
      inputMultiline: { padding: "12px", fontSize: "14px", lineHeight: "1.5" },
    },
  },
};
export default InputStyles;
